module.exports = __webpack_public_path__ + "static/img/About_3.b6d8ebe.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/aboutUsImages/About_3.jpg
// module id = hYk+
// module chunks = 11